export const ATTACHMENT_COMMENTS_FIELDS_NAME = {
	file: 'file',
	commentId: 'portal_comment_id'
}
